const VOICES = [
  {
    name: '阿柴不熬夜',
    role: '内容运营',
    text: '追热点的第一步就是看风向。这里的立场分布做得直观，我基本靠它判断评论区会不会吵起来。',
  },
  {
    name: '一颗柠檬',
    role: '普通网友',
    text: '以前刷到热门事件要先补一堆前情，现在看概述加几条高赞评论就懂了，省时间。',
  },
  {
    name: '南风知我意',
    role: '学生',
    text: '最喜欢它把不同立场摆在一起，不会只给我看一种声音，看完会自己多想一层。',
  },
];

export default function VoicesSection() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-10">
        <div className="mb-8 md:mb-10">
          <p className="text-xs md:text-sm font-medium text-accent-700 tracking-widest mb-2">VOICES / 围观者说</p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">大家为什么常来吃瓜</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {VOICES.map((voice) => (
            <figure
              key={voice.name}
              className="flex flex-col p-6 rounded-lg bg-accent-50 border border-accent-200/70"
            >
              <i className="ri-double-quotes-l text-3xl text-accent-500"></i>
              <blockquote className="mt-3 flex-1 text-sm text-foreground-700 leading-relaxed">{voice.text}</blockquote>
              <figcaption className="mt-5 pt-4 border-t border-accent-200/70 flex items-center gap-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-500 text-foreground-950 font-bold">
                  {voice.name.slice(0, 1)}
                </span>
                <span>
                  <span className="block text-sm font-bold text-foreground-900">{voice.name}</span>
                  <span className="block text-xs text-foreground-500">{voice.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}